import "./App.css";
import Login from "./components/Login";
import Home from "./components/Home";
import Register from "./components/Register";
import StatisticsPage from "./components/StatisticsPage";
import ProgramPage from "./components/ProgramPage";
import NotFoundPage from "./components/NotFoundPage";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useState, useEffect } from "react";
import jwtDecode from "jwt-decode";
import NavBar from "../src/components/NavBar";
import Logout from "./components/Logout.jsx";
import ProtectedRoute from "./components/ProtectedRoute";
import SearchProgram from "./components/SearchProgram";
import ProfilePage from "./components/ProfilePage";
import CVEpage from "./components/CVEpage";
import NewCVEsPage from "./components/NewCVEsPage";
import ProgramNewCVEPage from "./components/ProgramNewCVEPage";
import ManualSearchProgram from "./components/ManualSearchProgram";
//a
function App() {
  const navigate = useNavigate();

  const [user, setUser] = useState({});

  useEffect(() => {
    try {
      const jwt = localStorage.getItem("token");
      const user1 = jwtDecode(jwt);
      setUser(user1);
    } catch (e) {
      console.log(e);
    }
  }, []);

  return (
    <div className="content">
      <ToastContainer />

      <NavBar user={user} />

      <Routes>
        <Route path="/login" element={<Login user={user}></Login>}></Route>
        <Route path="/register" element={<Register></Register>}></Route>
        <Route path="/logout" element={<Logout></Logout>}></Route>
        <Route
          path="/statistics"
          element={<StatisticsPage></StatisticsPage>}
        ></Route>
        <Route
          path="/cpes-with-new-cves"
          element={<NewCVEsPage></NewCVEsPage>}
        ></Route>
        <Route
          path="/search-program"
          element={<SearchProgram></SearchProgram>}
        ></Route>
        <Route
          path="/manual-search-program"
          element={<ManualSearchProgram></ManualSearchProgram>}
        ></Route>
        <Route path="/cpes/:cpeId/cves" element={<ProgramPage></ProgramPage>} />
        <Route
          path="/cpes/:cpeId/new-cves"
          element={<ProgramNewCVEPage></ProgramNewCVEPage>}
        />
        <Route
          path="/cpes/:cpeId/cves/:cveCode"
          element={<CVEpage></CVEpage>}
        />
        <Route
          path="/profile"
          element={<ProfilePage user={user}></ProfilePage>}
        />
        <Route
          path="/"
          element={
            <ProtectedRoute user={user}>
              <Home></Home>
            </ProtectedRoute>
          }
        ></Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
}

export default App;
